export * from './Settings';
import Settings from './Settings';
export default Settings;
